<script lang="ts">
	import { onMount } from 'svelte';
	import type { URLState } from '../url-state';
	import { navigateTo } from '../url-state';
	import type { IdMap } from '../types';
	import { getTransactions } from '../api';
	import Transactions from './Transactions.svelte';

	let { urlState, id2trefwoord, trefwoordIds } = $props<{
		urlState: URLState;
		id2trefwoord: IdMap<string>;
		trefwoordIds: number[];
	}>();

	let mydata = $state<{
		id2trefwoord: IdMap<string>;
		trefwoordIds: number[];
		transactions: any[];
		totaal: number;
	}>({
		id2trefwoord: {},
		trefwoordIds: [],
		transactions: [],
		totaal: 0
	});

	async function loadData() {
		if (urlState.from && urlState.until && urlState.trefwoordId !== undefined) {
			try {
				mydata = await getTransactions(urlState.from, urlState.until, urlState.trefwoordId);
			} catch (error) {
				console.error('Failed to load transactions:', error);
			}
		}
	}

	function handleDataChanged() {
		loadData();
	}

	onMount(() => {
		loadData();
		window.addEventListener('dataChanged', handleDataChanged);
		return () => window.removeEventListener('dataChanged', handleDataChanged);
	});

	$effect(() => {
		if (urlState.from && urlState.until && urlState.trefwoordId !== undefined) {
			loadData();
		}
	});
</script>

<main>
	<h1>
		<a href="/" onclick={(e) => { e.preventDefault(); navigateTo('/', { from: urlState.from, until: urlState.until }); }}>Overzicht</a> > {id2trefwoord[urlState.trefwoordId || 0] ||
		mydata.id2trefwoord[urlState.trefwoordId || 0] || 'Alle'}
	</h1>
	<Transactions {mydata} />
</main>
